package app.alefly.domain.theme

private const val LIGHT_BACKGROUND_LUMINANCE_THRESHOLD = 0.58f

/**
 * ITU-R BT.601 relative luminance heuristic used to decide whether a background needs dark or
 * light feedback text to stay readable. Shared by web and mobile so both platforms make the same
 * call for a given per-tenant correct/incorrect color instead of drifting apart over time.
 *
 * @param red green blue Normalized channel values (0f..1f).
 */
public fun isLightBackground(red: Float, green: Float, blue: Float): Boolean {
    val luminance = red * 0.299f + green * 0.587f + blue * 0.114f
    return luminance >= LIGHT_BACKGROUND_LUMINANCE_THRESHOLD
}
